var map = {
	"./App": 9644,
	"./App.vue": 9644,
	"./assets/imgs/about-painting.webp": 9161,
	"./assets/imgs/about-photo.webp": 1712,
	"./assets/imgs/author.webp": 9260,
	"./assets/imgs/blank.webp": 9226,
	"./assets/imgs/home-blur.webp": 4220,
	"./assets/imgs/home-lg.webp": 4319,
	"./assets/imgs/home-sm.webp": 254,
	"./assets/imgs/home-xl.webp": 6798,
	"./components/ArtDialog": 6676,
	"./components/ArtDialog.vue": 6676,
	"./components/Gallery": 3785,
	"./components/Gallery.vue": 3785,
	"./components/Image": 5623,
	"./components/Image.vue": 5623,
	"./components/ImageHome": 3457,
	"./components/ImageHome.vue": 3457,
	"./components/Navigation": 6683,
	"./components/Navigation.vue": 6683,
	"./components/Presentation": 5330,
	"./components/Presentation.vue": 5330,
	"./components/TopBar": 6707,
	"./components/TopBar.vue": 6707,
	"./components/YearsDialog": 9478,
	"./components/YearsDialog.vue": 9478,
	"./content": 3180,
	"./content.json": 3180,
	"./main": 866,
	"./main.js": 866,
	"./plugins/vuetify": 9821,
	"./plugins/vuetify.js": 9821,
	"./plugins/webfontloader": 4992,
	"./plugins/webfontloader.js": 4992,
	"./router": 1120,
	"./router/": 1120,
	"./router/index": 1120,
	"./router/index.js": 1120,
	"./store": 4239,
	"./store/": 4239,
	"./store/index": 4239,
	"./store/index.js": 4239,
	"./views/About": 3277,
	"./views/About.vue": 3277,
	"./views/Drawnings": 9079,
	"./views/Drawnings.vue": 9079,
	"./views/Graphics": 4268,
	"./views/Graphics.vue": 4268,
	"./views/Home": 7015,
	"./views/Home.vue": 7015,
	"./views/NotFound": 4404,
	"./views/NotFound.vue": 4404,
	"./views/Paintings": 2943,
	"./views/Paintings.vue": 2943,
	"./views/Poetry": 8629,
	"./views/Poetry.vue": 8629,
	"./views/Portraits": 8310,
	"./views/Portraits.vue": 8310,
	"./views/Projects": 9731,
	"./views/Projects.vue": 9731,
	"./views/Sculptures": 827,
	"./views/Sculptures.vue": 827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;